// src/components/ThemeToggleButton.js
import React, { useState, useEffect } from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/solid';

const ThemeToggleButton = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    // --- CHANGE: Redesigned button for a more polished look and feel ---

    <button
      onClick={toggleTheme}
      className="relative p-3 rounded-full text-content-primary hover:text-yellow-500 hover:bg-yellow-500/10 focus:outline-none focus:ring-offset-background-secondary focus:ring-yellow-500 transition-colors"
      aria-label="Toggle theme"
    >
      {/* Sun Icon - Visible in Light Mode */}
      <SunIcon
        className={`h-6 w-6 transition-all duration-300 ease-in-out
          ${theme === 'light' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'}
        `}
      />
      {/* Moon Icon - Visible in Dark Mode */}
      <MoonIcon
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-6 w-6 transition-all duration-300 ease-in-out
          ${theme === 'dark' ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0'}
        `}
      />
    </button>
  );
};

export default ThemeToggleButton;
